import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface HeadacheSectionProps {
  readonly currentPage: number;
}

export const HeadacheSection: React.FC<HeadacheSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 6 && (
        <SurveyQuestionCard
          sectionTag="HEADACHE"
          title="Have you had any headaches during dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you had headaches recently"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouHadHeadAches")}
              onChange={e => {
                localStorage.setItem("haveYouHadHeadAches", e.target.value);
              }}
            >
              <AnswerList>
                <AnswerOption value="NO">NO</AnswerOption>
                <AnswerOption value="Rarely (1 - 2 / Month)">
                  Rarely (1 - 2 / Month)
                </AnswerOption>
                <AnswerOption value="Occasional (3 - 4 / Month)">
                  Occasional (3 - 4 / Month)
                </AnswerOption>
                <AnswerOption value="Frequent (5 - 10 / Month)">
                  Frequent (5 - 10 / Month)
                </AnswerOption>
                <AnswerOption value="Every dialysis (11 - 13 / Month)">
                  Every dialysis (11 - 13 / Month)
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
